import { TabletOutlined, UserOutlined } from '@ant-design/icons';

const typesStyles = {
  created: {
    color: 'red-state',
    text: 'Examen no tomado',
  },
  done: {
    color: 'green-state',
    text: 'Examen tomado',
  },
  occupied: {
    color: 'yellow-state',
    text: 'Tomando examen',
  },
  reevaluate: {
    color: 'purple-state',
    text: 'Examen a reevaluar'
  },
  inProgress: {
    color: 'gray-state',
    text: 'Examen en curso no terminado'
  },
  fromJourney: {
    color: 'yellow-state',
    text: 'Tomando encuesta desde Journey',
    icon: <UserOutlined />
  },
  fromDevice: {
    color: 'yellow-state',
    text: 'Tomando encuesta desde dispositivo',
    icon: <TabletOutlined />
  },
};

export default typesStyles;